import React from "react";
import { Carousel } from "react-bootstrap";

const Slider = ({ children, className }) => {
  return (
    <Carousel
      className={className}
      controls={false}
      indicators={true}
    >
      {children}
    </Carousel>
  );
};

export default Slider;
